import { forwardRef as p } from "react";
import * as m from "@radix-ui/react-separator";
import { useThemeUI as f } from "theme-ui";
import { jsx as i } from "theme-ui/jsx-runtime";
const x = p((t, a) => {
  var o;
  const {
    sx: e,
    ...s
  } = t, {
    theme: r
  } = f();
  return /* @__PURE__ */ i(m.Root, {
    ref: a,
    sx: {
      ...(o = r.styles) == null ? void 0 : o.hr,
      ...r.separator,
      ...e
    },
    ...s
  });
});
x.displayName = "SeparatorHr";
export {
  x as SeparatorHr
};
